
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M21.463.64c11.505 0 20.831 9.326 20.831 20.83 0 11.505-9.326 20.831-20.83 20.831-11.505 0-20.831-9.326-20.831-20.83C.633 9.965 9.959.638 21.463.638zm8.992 14.826c-.401 0-.803.153-1.109.46l-7.892 7.873-8.498-8.257a1.569 1.569 0 00-1.594.384l-.939.939c-.306.306-.46.707-.46 1.11 0 .4.154.802.46 1.109l9.93 9.93c.307.307.709.46 1.11.46.402 0 .803-.153 1.11-.46l9.93-9.93c.307-.307.46-.708.46-1.11 0-.402-.153-.803-.46-1.11l-.938-.938a1.564 1.564 0 00-1.11-.46z"}})])
          )
        }
      }
    